/* eslint-disable @typescript-eslint/no-unused-vars */
'use client';

import LoadingAddBankAccountSetting from "./addBankAccountSetting";
import LoadingAddCurriculum from "./addCurriculum";
import LoadingAddExtension from "./addExtension";
import LoadingAddNotification from "./addNotification";
import LoadingApproveFinancialRequestId from "./approveFinancialRequestid";
import LoadingBankAccountSetting from "./bankAccountSetting";
import LoadingBankAccountSettingId from "./bankAccountSettingid";
import LoadingCreateFinancialRequest from "./createFinancialRequest";
import LoadingCreateHistoryTransaction from "./createHistoryTransaction";
import LoadingCurriculum from "./curriculum";
import LoadingCurriculumId from "./curriculumid";
import LoadingDefaultXstudio from "./LoadingDefaultXstudio";
import LoadingExtension from "./extension";
import LoadingExtensionId from "./extensionid";
import LoadingHistoryTransaction from "./historyTransaction";
import LoadingMoneyTransferSetup from "./moneyTransferSetup";
import LoadingNotification from "./notification";
import LoadingNotificationId from "./notificationid";
import LoadingRemove from "./LoadingRemove";
import LoadingRoot from "./loadingRoot";
import LoadingStudent from "./student";
import LoadingStudentId from "./studentid";
import LoadingStudyPlan from "./studyPlan";
import LoadingTransaction from "./transaction";

const LoadingLayoutComponent = ({ pathname }: { pathname: string }) => {

  const findMatchingRoute = (pathname: string) => {

    const normalizedPath = pathname === '/' ? '/' : pathname.replace(/\/$/, '')

    const routes: any = [
      { pattern: '/student', component: 'LoadingStudent' },
      { pattern: '/', component: 'LoadingRoot' },
      { pattern: '/transaction', component: 'LoadingTransaction' },
      { pattern: '/notification', component: 'LoadingNotification' },
      { pattern: '/add-notification', component: 'LoadingAddNotification' },
      { pattern: '/add-extension', component: 'LoadingAddExtension' },
      { pattern: '/create-history-transaction', component: 'LoadingCreateHistoryTransaction' },
      { pattern: '/create-financial-request', component: 'LoadingCreateFinancialRequest' },
      { pattern: '/money-transfer-setup', component: 'LoadingMoneyTransferSetup' },
      { pattern: '/add-bank-account-setting', component: 'LoadingAddBankAccountSetting' },
      { pattern: '/history-transaction', component: 'LoadingHistoryTransaction' },
      { pattern: '/extension', component: 'LoadingExtension' },
      { pattern: '/bank-account-setting', component: 'LoadingBankAccountSetting' },
      { pattern: '/curriculum', component: 'LoadingCurriculum' },
      { pattern: '/add-curriculum', component: 'LoadingAddCurriculum' },
      { pattern: '/study-plan', component: 'LoadingStudyPlan' }

    ]

    for (const route of routes) {
      if (route.pattern === normalizedPath) {
        return route.component;
      }
    }

    const segments = normalizedPath.split('/').filter(Boolean);
if (segments[0] === 'about' && segments[1]) {
      return 'LoadingAboutId';
    }
    if (segments[0] === 'student' && segments[1]) {
      return 'LoadingStudentId';
    }
    if (segments[0] === 'extension' && segments[1]) {
      return 'LoadingExtensionId';
    }
    if (segments[0] === 'notification' && segments[1]) {
      return 'LoadingNotificationId';
    }
    if (segments[0] === 'approve-financial-request' && segments[1]) {
      return 'LoadingApprove-financial-requestId';
    }
    if (segments[0] === 'bank-account-setting' && segments[1]) {
      return 'LoadingBank-account-settingId';
    }
    if (segments[0] === 'curriculum' && segments[1]) {
      return 'LoadingCurriculumId';
    }

    return 'LoadingDefaultXstudio';
  }

  const componentMap: Record<string, React.ComponentType> = {
    'LoadingRoot': LoadingRoot,
    'LoadingDefaultXstudio': LoadingDefaultXstudio,
    'LoadingRemove': LoadingRemove,
    'LoadingTransaction': LoadingTransaction,
    'LoadingNotification': LoadingNotification,
    'LoadingAddNotification': LoadingAddNotification,
    'LoadingStudent': LoadingStudent,
    'LoadingExtensionId': LoadingExtensionId,
    'LoadingAddExtension': LoadingAddExtension,
    'LoadingCreateHistoryTransaction': LoadingCreateHistoryTransaction,
    'LoadingNotificationId': LoadingNotificationId,
    'LoadingCreateFinancialRequest': LoadingCreateFinancialRequest,
    'LoadingMoneyTransferSetup': LoadingMoneyTransferSetup,
    'LoadingAddBankAccountSetting': LoadingAddBankAccountSetting,
    'LoadingHistoryTransaction': LoadingHistoryTransaction,
    'LoadingStudentId': LoadingStudentId,
    'LoadingExtension': LoadingExtension,
    'LoadingBankAccountSetting': LoadingBankAccountSetting,
    'LoadingCurriculum': LoadingCurriculum,
    'LoadingAddCurriculum': LoadingAddCurriculum,
    'LoadingStudyPlan': LoadingStudyPlan,
    'LoadingCurriculumId': LoadingCurriculumId
  };

  const componentName = findMatchingRoute(pathname);

  const Component = componentMap[componentName] || LoadingDefaultXstudio

  return <Component />
};

export default LoadingLayoutComponent;